import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  display: flex;
  width: 100%;
  height: auto;

  .AreaSectionWrapper {
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    @media(min-width: 992px) {
      margin: 30px;
    }

    .AreaContentWrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: rgba(255,255,255,.93);
      width: 95vw;
      max-width: 900px;
      padding: 5vh 5vw;
      margin: 85px 0;
      @media(min-width: 768px) {
        width: 65vw;
      }

      h2 {
        color: ${colors.brand1};
        font-size: 45px;
        font-weight: 300;
        @media(min-width: 768px) {
          font-size: 58px;
        }
      }

      p {
      font-size: 14px;
      letter-spacing: 0.36px;
      line-height: 20px;
      @media(min-width: 768px) {
        font-size: 16px;
        line-height: 24px;
      }
      }
    }
  }
`;

function AreaInfo({ area, widget }) {
  return (
    <div className={styles}>
      <div style={{ backgroundImage: `url(${buildThumbnailUrl(get(area, 'logo.contentUrl', '') || get(widget, 'area_image.contentUrl', ''), { width: 1600, height: 1600 })})` }} className="AreaSectionWrapper">
        <div className="AreaContentWrapper">
          <h2>{get(area, 'name') || get(widget, 'area_name')}</h2>
          <div dangerouslySetInnerHTML={SanitizeHtml(get(area, 'description') || get(widget, 'area_description'))} />
        </div>
      </div>
    </div>
  );
}

AreaInfo.propTypes = {
  area: PropTypes.object,
  widget: PropTypes.object.isRequired,
};

AreaInfo.defaultProps = {
  area: undefined,
};

export default withData(
  {
    area: true,
    widget: 'default_area',
  },
  {
    required: {
      communities: true,
      widget: true,
    },
  },
)(AreaInfo);



// WEBPACK FOOTER //
// ./src/components/AreaInfo.js